import { useLang } from "../../lib/i18n";

const BRANDS = [
    ["Michelin", "ميشلان"],
    ["Bridgestone", "بريدجستون"],
    ["Continental", "كونتيننتال"],
    ["Pirelli", "بيريلي"],
    ["Goodyear", "جوديير"],
    ["Dunlop", "دنلوب"],
    ["Hankook", "هانكوك"],
    ["Yokohama", "يوكوهاما"],
    ["Kumho", "كومهو"],
    ["Nexen", "نيكسن"],
];

export const BrandMarquee = () => {
    const { lang } = useLang();
    const isAr = lang === "ar";

    return (
        <div
            className="relative border-y border-white/10 bg-[#0C1634] py-5 overflow-hidden"
            data-testid="brand-marquee"
        >
            <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0C1634] to-transparent z-10" />
            <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0C1634] to-transparent z-10" />
            <div dir="ltr" className="flex w-max animate-marquee gap-0">
                {[...BRANDS, ...BRANDS].map(([en, ar], i) => (
                    <div key={i} className="flex items-center gap-3 px-8 shrink-0" dir={isAr ? "rtl" : "ltr"}>
                        <span className="w-1 h-1 rotate-45 bg-red-600" />
                        <span className="font-display font-bold text-lg text-slate-500 hover:text-amber-400 transition-colors duration-300">
                            {isAr ? ar : en}
                        </span>
                        <span className="font-mono-spec text-[10px] tracking-[0.25em] text-slate-700">
                            {isAr ? en.toUpperCase() : ar}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};
